import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import * as _ from 'lodash';
import { PublicPartnerApiService } from './publicpartnerapi.service';
import { Store } from '@ngrx/store';
import { ConfigService } from '@gridscale/ingrid/helper/services/config.service';

export interface PublicApiErrorResponse extends HttpErrorResponse {
  method: string;
}

// unwrap Promise Return Type... (@see https://jpwilliams.dev/how-to-unpack-the-return-type-of-a-promise-in-typescript)
type Unwrap<T> = T extends Promise<infer U> ? U : T extends (...args: any) => Promise<infer U> ? U : T extends (...args: any) => infer U ? U : T;

@Injectable({
  providedIn: 'root'
})
export class ContractManagementApiService extends PublicPartnerApiService {
  readonly #configService = inject(ConfigService)
  constructor(http: HttpClient, store: Store) {
    super(http, store);

    this.#configService.ready$.pipe(
      filter(ready => !!ready),
    ).subscribe(() => {
      this.current_endpoint = this.#configService.coreAPI;
    })

  }

  /**
   * Catch Errors in Management API for Deleted Contracts, we just return an Empty object in that case
   * @deprecated
   * See ForkJoin in contractEffect
   * @param _url
   * @returns
   */
  getContract<T>(_url: string) {
    return new Promise((resolve, reject) => {
      this.get<T>(_url)
        .pipe(
          map((result) => {
            resolve(result);
          }),
          catchError(error => {
            resolve({}); // Return an Empy Object if that is a deleted contract
            return of('1');
          })
        )
        .subscribe();
    });
  }
}
